<div class="messages-component" [formGroup]="form">
  <div class="form-section">
    <h4>{{ "NEW_INJECTS.TEAM_NAME" | translate }}</h4>
    <div class="form-row" formGroupName="group_name">
      @for (lang of languages; track lang) {
        <div class="form-group">
          <label [for]="'group_name_' + lang">{{ lang | uppercase }}:</label>
          <input
            type="text"
            [id]="'group_name_' + lang"
            [formControl]="getGroupNameControl(lang)"
            class="form-control"
            />
        </div>
      }
    </div>
  </div>

  <div class="form-section">
    <h4>{{ "ADMIN.SESSION.RESULT.MESSAGES" | translate }}</h4>
    <div class="messages-container" formGroupName="messages">
      @for (lang of languages; track lang) {
        <div class="language-section">
          <h5>
            {{ "ADMIN.SESSION.RESULT.MESSAGES" | translate }} ({{
            lang | uppercase
            }})
          </h5>
          @for (
            messageControl of getMessagesArray(lang).controls; track
            messageControl; let i = $index) {
            <div
              class="message-item"
              >
              <div class="message-header">
                <span class="message-number"
                  >{{ "NEW_INJECTS.MESSAGE" | translate }} {{ i + 1 }}</span
                  >
                  <button
                    type="button"
                    class="btn-remove"
                    (click)="removeMessage(lang, i)"
                    >
                    ×
                  </button>
                </div>
                <div class="form-row" [formGroup]="messageControl">
                  <div class="d-flex align-items-end">
                    <div class="form-group">
                      <label [for]="'name' + i"
                        >{{ "ADMIN.COMPANY.PEOPLE.NAME" | translate }}:</label
                        >
                        <input
                          type="text"
                          formControlName="name"
                          class="form-control"
                          [id]="'name' + i"
                          />
                      </div>
                      <div class="upload-block">
                        <div class="hidden">
                          <input
                            type="text"
                            formControlName="avatar_image_id"
                            placeholder="Enter avatar image ID"
                            class="form-control"
                            />
                        </div>
                        @if (!messageControl.get('avatar_image_id')?.value) {
                          @if (avatars.length) {
                            <button
                              type="button"
                              mat-button
                              class="btn-upload btn btn-primary"
                              [matMenuTriggerFor]="avatarMenu"
                              (click)="setCurrentControl(lang, i)"
                            >
                              {{ "NEW_INJECTS.AVATAR" | translate }}
                            </button>
                            <mat-menu #avatarMenu="matMenu">
                              @for (avatar of avatars; track avatar.id) {
                                <button
                                  mat-menu-item
                                  (click)="selectAvatarFromList(avatar)"
                                >
                                  <span
                                    class="avatar-item"
                                    [style.backgroundImage]="
                                      'url(' + avatar.link + ')'
                                    "
                                  ></span>
                                </button>
                              }
                              <button
                                mat-menu-item
                                class="media-picker-menu__upload"
                                (click)="openAvatarUpload(lang, i)"
                              >
                                {{
                                  "ADMIN.SESSION.SCENARIO_ITEM.UPLOAD_NEW"
                                    | translate
                                }}
                              </button>
                            </mat-menu>
                          } @else {
                            <button
                              type="button"
                              class="btn-upload btn btn-primary"
                              (click)="openAvatarUpload(lang, i)"
                            >
                              {{ "NEW_INJECTS.AVATAR" | translate }}
                            </button>
                          }
                        }
                        @if (messageControl.get('avatar_image_id')?.value) {
                          <div
                            class="avatar-block"
                            >
                            <div
                              class="preview_avatar mt-1"
                    [style.backgroundImage]="
                      'url(' +
                      getMediaUrl(
                        messageControl.get('avatar_image_id')?.value
                      ) +
                      ')'
                    "
                            ></div>
                            <span
                              class="remove-avatar"
                    (click)="
                      removeAvatar(messageControl.get('avatar_image_id'))
                    "
                              ><mat-icon>close</mat-icon></span
                              >
                            </div>
                          }
                        </div>
                      </div>
                      <div class="form-group">
                        <label [for]="'message' + i"
                          >{{ "NEW_INJECTS.MESSAGE" | translate }}:</label
                          >
                          <textarea
                            formControlName="message"
                            class="form-control"
                            rows="3"
                            [id]="'message' + i"
                          ></textarea>
                        </div>
                        <div class="form-group">
                          <label>
                            <input
                              type="checkbox"
                              formControlName="is_own_message"
                              class="form-check-input"
                              />
                            {{ "NEW_INJECTS.IS_OWN_MESSAGE" | translate }}
                          </label>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn-add" (click)="addMessage(lang)">
                    + {{ "NEW_INJECTS.ADD_MESSAGE" | translate }} ({{ lang | uppercase }})
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="hidden">
          <app-file-upload
            (upload)="onAvatarFile($event)"
            [clearAfterUpload]="true"
            [accept]="acceptImageFormats"
            #uploadFile
          ></app-file-upload>
        </div>
